import { StaffEndpoints } from '@/modules/staff/api/staffEndpoints'

/**
 * Staff endpoint instance
 * instantiate staff api class with different api path
 */
export const staffEndpoints = new StaffEndpoints()
